import { KpiCard, Avatar, HorizontalBarChart, DonutChart, Chip, Alert } from '@/components/ui'
import { MessageCircle, Clock, TrendingUp, Star, Lightbulb } from 'lucide-react'
import { agentes } from '@/mock'
import { cn } from '@/lib/utils'

export function Kpis() {
  const razones = [
    { label: '💼 Plan de pago custom', value: 142, total: 487, color: '#3b82f6' },
    { label: '💬 Pidió asesor explícito', value: 118, total: 487, color: '#10b981' },
    { label: '🤖 IA no pudo (3 intentos)', value: 98, total: 487, color: '#8b5cf6' },
    { label: '📸 Comprobante rechazado', value: 67, total: 487, color: '#f43f5e' },
    { label: '⚠ Tono agresivo', value: 42, total: 487, color: '#e11d48' },
    { label: 'Otros', value: 20, total: 487, color: '#94a3b8' },
  ]

  const medallas = ['🥇', '🥈', '🥉', '', '']

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <KpiCard label="Chats atendidos (mes)" value="487" sub="↑ +12%" icon={<MessageCircle className="w-3.5 h-3.5" />} color="emerald" />
        <KpiCard label="Tiempo prom resolución" value="14 min" sub="↓ -3 min vs ant." icon={<Clock className="w-3.5 h-3.5" />} color="emerald" />
        <KpiCard label="Tasa resolución" value="89%" sub="11% escalado jefe" icon={<TrendingUp className="w-3.5 h-3.5" />} color="emerald" />
        <KpiCard label="Satisfacción cliente" value={<span>4.6<span className="text-base ml-0.5">★</span></span>} sub="342 ratings" icon={<Star className="w-3.5 h-3.5" />} color="amber" />
      </div>

      <section className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        <header className="px-5 py-4 border-b border-slate-200">
          <h2 className="font-display text-lg text-navy-700">Ranking de agentes</h2>
          <p className="text-xs text-slate-500 mt-0.5">Ordenado por tasa de resolución</p>
        </header>
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-600 font-semibold">
            <tr>
              <th className="text-left px-5 py-2">Agente</th>
              <th className="text-right px-5 py-2">Atendidos</th>
              <th className="text-right px-5 py-2">Resueltos</th>
              <th className="text-right px-5 py-2">Escalados</th>
              <th className="text-right px-5 py-2">T. promedio</th>
              <th className="text-right px-5 py-2">Satisfacción</th>
              <th className="text-left px-5 py-2">Estado</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {agentes.map((a, i) => {
              const escalados = a.chats - a.resueltos
              return (
                <tr key={a.nombre} className="hover:bg-slate-50">
                  <td className="px-5 py-3">
                    <div className="flex items-center gap-3">
                      <span className="text-xl w-6">{medallas[i]}</span>
                      <Avatar name={a.nombre} size="sm" />
                      <span className="font-semibold text-navy-700">{a.nombre}</span>
                    </div>
                  </td>
                  <td className="px-5 py-3 text-right font-mono text-slate-700">{a.chats}</td>
                  <td className="px-5 py-3 text-right font-mono text-emerald-600 font-semibold">
                    {a.resueltos} <span className="text-slate-400 text-xs">({a.tasa}%)</span>
                  </td>
                  <td className="px-5 py-3 text-right font-mono text-slate-700">{escalados}</td>
                  <td className="px-5 py-3 text-right font-mono text-slate-700">{a.tiempo} min</td>
                  <td className="px-5 py-3 text-right">
                    <span className="inline-flex items-center gap-0.5">
                      <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
                      <span className="font-mono font-semibold text-amber-600">{a.rating}</span>
                    </span>
                  </td>
                  <td className="px-5 py-3">
                    {a.estado === 'online' ? (
                      <Chip variant="emerald"><span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald-500 mr-1 animate-pulse" /> En línea</Chip>
                    ) : (
                      <Chip variant="default">● Offline</Chip>
                    )}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </section>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <section className="bg-white border border-slate-200 rounded-xl p-5">
          <header className="mb-3">
            <h2 className="font-display text-lg text-navy-700">Razones de escalación · Este mes</h2>
            <p className="text-xs text-slate-500">Qué hace que el cliente llegue a humano</p>
          </header>
          <HorizontalBarChart items={razones} />
        </section>

        <section className="bg-white border border-slate-200 rounded-xl p-5">
          <header className="mb-3">
            <h2 className="font-display text-lg text-navy-700">IA vs Humano · Resolución global</h2>
            <p className="text-xs text-slate-500">De todos los mensajes recibidos este mes</p>
          </header>
          <div className="flex items-center justify-center gap-6">
            <DonutChart
              size={180}
              segments={[
                { label: 'IA resolvió sola', value: 72, color: '#10b981' },
                { label: 'Escalado humano', value: 28, color: '#f59e0b' },
              ]}
              centerValue="72%"
              centerLabel="Auto IA"
            />
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <span className="w-3 h-3 rounded-sm bg-emerald-500" />
                <span>IA resolvió sola</span>
                <span className="font-mono text-slate-500 ml-2">2,841 (72%)</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-3 h-3 rounded-sm bg-amber-500" />
                <span>Escalado a humano</span>
                <span className="font-mono text-slate-500 ml-2">1,105 (28%)</span>
              </li>
            </ul>
          </div>
        </section>
      </div>

      <Alert variant="tip" title={<span className="flex items-center gap-2"><Lightbulb className="w-4 h-4" /> Insight accionable</span>}>
        La IA resuelve 7 de cada 10 chats. Los que escalan son principalmente negociaciones de plan de pago (29%) — <strong>podríamos crear FAQ específicas para planes simples y bajar escalaciones un 15%</strong>.
      </Alert>
    </div>
  )
}
